'use strict';

var App = require('app');
var AppState = require('app_state');
var ColumnsDialogView = require('components/common/views/columns_dialog_view');
var CommonViews = require('components/common/views');
var i18n = require('utils/i18n');
var Notification = require('utils/notification');
var ConfirmDeleteDevicesDialogView = require('components/devices/views/common/confirm_delete_devices_dialog_view');

var CommonUtils = {};

CommonUtils.showLoadingHint = function (title) {
    var hintView = new CommonViews.Hint({
        title: title,
        isActivating: true,
    });
    App.main.show(hintView);
};

CommonUtils.showHint = function (config) {
    var hintView = new CommonViews.Hint({
        title: config.title,
        hint: config.hint,
        hintClass: config.hintClass,
        footer: i18n.TR('Sie werden in wenigen Augenblicken zur Startseite umgeleitet.'),
        isActivating: false,
        hintID: config.hintID || 'hint',
    });
    App.main.show(hintView);

    setTimeout(function () {
        App.trigger('home:show', config);
    }, 2500);
};

CommonUtils.showConfirmationDialog = function (config) {
    App.showModal(new CommonViews.Confirmation(config));
};

CommonUtils.showConfigureColumnsDialog = function (config) {
    var columnsDialogView = new ColumnsDialogView({
        fields: AppState.uniqueFields(config.columnCategory),
        selected: AppState.selectedColumns(config.category),
        category: config.columnCategory,
        save_cb: function (newSelection) {
            config.update_cb(newSelection);
            AppState.saveSelectedColumns(config.category);
        },
    });
    App.showModal(columnsDialogView);
};

CommonUtils.showPasswordHintPopover = function ($element, pwConstraints, passwordOk) {
    if (document.getElementById('js-password-hints') === null) {
        $element.popover({
            html: true,
            placement: 'right',
            trigger: 'focus',
            animation: false,
            content: '',
        });
    }

    var template = require('components/account/templates/password_hints');
    $element.data('bs.popover').options.content = template({
        length: pwConstraints.length,
        number: pwConstraints.number,
        cases: pwConstraints.cases,
        specialChar: pwConstraints.specialChar,
        passwordOk: passwordOk,
    });

    $element.popover(passwordOk ? 'hide' : 'show');
};

CommonUtils.createDropDownChecklist = function (element, options) {
    // when it's called with multiple objects, calls itself with each single object
    var commonUtils = this;

    if (element.length > 1) {
        element.each(function (i, x) {
            commonUtils.createDropDownChecklist([x], options);
        });

        return;
    }

    // set defaults
    var defaults = {
        // Template for the hint (complete text of selected options)
        hintTemplate: '<div><small data-checklist-hint>$</small></div>',
        // event triggered when the popup list is dismissed
        dismissedChanged: function () {},
        // the message shown when there are no options to display
        noOptions: i18n.TR('keine Option verfügbar'),
    };

    var select = element;
    var opts = $.extend({}, defaults, options);

    // hide immediately
    $(select).hide();
    element.lastSubmittedValue = '';

    var emptyText = $(select).data('empty');
    var isRadio = $(select).data('radio');

    var items = [];
    $(select)
        .find('option')
        .each(function (i, opt) {
            items.push({
                value: $(opt).prop('value'),
                text: $(opt).html(),
                icon: $(opt).attr('data-icon'),
            });
        });

    var checkListTemplate = require('components/common/templates/dropdown_checklist');

    $(select).after(
        checkListTemplate({
            displayText: emptyText,
            items: items,
            noOptions: opts.noOptions,
        })
    );

    var button = $(element).next();
    var ul = $(button).next();
    var listItems = $(ul).find('a');
    var checkBoxes = $(ul).find('a').find('input[type=checkbox]');
    var hintContent = $(select).nextAll().find('[data-checklist-hint]');

    var setHint = function (hintText) {
        if (hintText === '') hintText = '&nbsp;';

        $(hintContent).html(hintText);
    };

    // calls the function with every checked item
    var eachChecked = function (func) {
        listItems.each(function (i, row) {
            var isChecked = $(row).find('input[type=checkbox]').prop('checked');
            if (isChecked) {
                func(row);
            }
        });
    };

    // builds a select option for the invisbile select as a list of checked items
    var checkedValuesToSelect = function () {
        var content = '';
        eachChecked(function (row) {
            content += (content == '' ? '' : ',') + $(row).data('value');
        });

        // put it into the select
        $(select).html('<option value="' + content + '" selected>' + content + '</option>');
    };

    // builds the text
    var displaySelectedOptions = function () {
        var content = '';

        // convert HTML to plain text
        var toPlainText = function (str) {
            // get rid of HTML
            str = $('<p>' + str + '</p>').text();
            return str.trim();
        };

        eachChecked(function (obj) {
            var separator = content === '' ? '' : ', ';
            var plaintext = toPlainText($(obj).html());

            content = content + separator + plaintext;
        });

        // display a message when there are no selected items
        content = content.trim();
        setHint(content);
        if (content.length == 0) {
            content = emptyText;
        }
        $(button).find('span').first().html(content);
    };

    // changes the button text, the hint, and the value of the select to correspond with the selection
    var setSelection = function () {
        checkedValuesToSelect();
        displaySelectedOptions();
    };

    // sets the initial value of the drop down list (the initial value can be as comma-separated list in the tag data-value)
    var setInitialValue = function () {
        var initialValue = '' + $(select).data('selected');
        if (initialValue) {
            initialValue = initialValue.split(',');
            $(initialValue).each(function (i, value) {
                $(ul)
                    .find('[data-value="' + value + '"]')
                    .find('input[type=checkbox]')
                    .prop('checked', 'checked');
            });
        }
    };

    var clickHandler = function (el) {
        if (isRadio) {
            $(ul).find('input[type=checkbox]').prop('checked', false);
        }

        var chkBox = $(el).find('input[type=checkbox]');
        setTimeout(function () {
            chkBox.prop('checked', !chkBox.prop('checked'));
            setSelection();
        }, 1);
    };

    // triggers the response after selecting a checkbox
    element.chkClickHandler = function (e) {
        e.preventDefault();
        e.stopPropagation();

        clickHandler(e.currentTarget);
        return false;
    };

    // set events
    listItems.on('click', element.chkClickHandler);

    // response to the event when the drop down is dismissed
    $(button)
        .parent()
        .on('hidden.bs.dropdown', function () {
            var v = $(select).val();
            // the event is triggered only when the selection is changed
            if (v != select.lastSubmittedValue) {
                if (opts.dismissedChanged) {
                    opts.dismissedChanged(v);
                }
            }

            select.lastSubmittedValue = v;
        });

    // initialize
    setInitialValue();
    setSelection();
    select.lastSubmittedValue = $(select).val();

    if (isRadio) {
        var checked = 0;
        var first = undefined;
        _.each($(ul).find('input[type=checkbox]'), function (x) {
            if (first === undefined) first = x;
            checked += $(x).prop('checked') ? 1 : 0;
        });

        if (checked == 0) {
            $(first).prop('checked', true);
            setSelection();
        }
    }
};

CommonUtils.showTooltip = function (event) {
    var $element = $(event.target);
    $element.tooltip('show');
    // hide tooltip when leaving the target
    $element.one('mouseleave', function () {
        $element.tooltip('hide');
    });
    // hide tooltip after some delay
    setTimeout(function () {
        $element.tooltip('hide');
    }, 2500);
};

CommonUtils.deleteModels = function (deleteReq) {
    var deleteFct =
        deleteReq.deleteFct ||
        function (modelsToDelete, defer) {
            var count = _.keys(modelsToDelete).length;
            var failed = 0;

            var modelCompleted = function () {
                count--;
                if (count == 0) {
                    defer.resolve(failed == 0);
                }
            };

            _.each(modelsToDelete, function (model, idx) {
                model.toggleSelected();
                model.destroy({
                    success: function () {
                        modelCompleted();
                    },
                    error: function (model, response, options) {
                        failed++;
                        modelCompleted();
                    },
                });
            });
        };

    var errFct =
        deleteReq.error ||
        function () {
            Notification.show('error', i18n.TR('Fehler'), i18n.TR('Eintrag konnte nicht gelöscht werden.'));
        };
    var successFct = deleteReq.success || function () {};

    var models = deleteReq.models;
    var count = models ? _.keys(models).length : 0;
    if (!count) {
        return;
    }

    var modelsToDelete = _.values(models);

    var tail = count > 1 ? count + ' ' + i18n.TR('Einträge löschen?') : i18n.TR('den Eintrag löschen?');
    var dialogOptions = {
        title: i18n.TR('Einträge löschen'),
        hint: i18n.TR('Wollen Sie wirklich') + ' ' + tail,
        action_label: i18n.TR('Löschen'),

        action_cb: function () {
            var deleteDefer = $.Deferred();
            var promise = deleteDefer.promise();

            deleteFct(modelsToDelete, deleteDefer);

            $.when(promise).done(function (success) {
                if (!success) {
                    errFct();
                    return;
                }
                successFct();
            });
        },
    };

    if (modelsToDelete[0].attributes.modelType == 'device') {
        var d = $.Deferred();
        App.ajax({
            url: '/api/v1/devices/cleanup',
            method: 'GET',
            data: {
                device_ids: JSON.stringify(_.pluck(modelsToDelete, 'id')),
            },
            success: function (result) {
                d.resolve(result);
            },
            error: function (result) {
                d.resolve(undefined);
            },
        });

        $.when(d).done(function (result) {
            App.showModal(
                new ConfirmDeleteDevicesDialogView(
                    $.extend(dialogOptions, {
                        sourceDeviceInfos: result,
                    })
                )
            );
        });
    } else {
        CommonUtils.showConfirmationDialog(dialogOptions);
    }
};

CommonUtils.isInternetExplorer = function () {
    // see https://stackoverflow.com/questions/21825157/internet-explorer-11-detection
    return navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > -1;
};

module.exports = CommonUtils;
